import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const ProjectList = lazy(() => import('../../pages/project/project/ProjectList'));
const ProjectDetails = lazy(() => import('../../pages/project/project/ProjectDetails'));
const AddProject = lazy(() => import('../../pages/project/project/AddProject'));
const UpdateProject = lazy(() => import('../../pages/project/project/UpdateProject'));

export const ProjectImport = {
    RoutesMap,
    ProjectList,
    ProjectDetails,
    AddProject,
    UpdateProject,
}